import { useDispatch } from 'react-redux'
import { notify } from 'store/alertReducer'

export const useNotification = () => {
  const dispatch = useDispatch()

  return (options) => {
    dispatch(notify(options))
  }
}
